// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121025/js/" + chunkId + "." + {"44":"bd3c4799","225":"97b6c4e6","481":"6130a3f9","486":"aea5bc23","770":"52d66b39"}[chunkId] + ".0.1751151818145501.chunk.js";
};